module.exports = __webpack_public_path__ + "media/images/responsive/logo/logo_aqua_white-8684d76fa3e6524ff403007bcc1af2de.svg";